import type { GameSnapshot, ProjectedGameState } from '../socket';

// One player's board-format line, resolved from live game data. The same
// fields the playerStatsTable widget shows, plus reb/ast for richer effects.
export interface PlayerLine {
  no: string;    // jersey, '-' if none
  name: string;  // UPPERCASE, matching the board
  f: number;     // fouls
  pts: number;
  reb: number;
  ast: number;
}

export function resolvePlayerLine(
  snapshot: GameSnapshot | null,
  state: ProjectedGameState | null,
  side: 'home' | 'away',
  playerId: string,
): PlayerLine | null {
  const p = snapshot?.rosters[side]?.players.find((pl) => pl.id === playerId);
  if (!p) return null;
  const s = state?.playerStats?.[playerId] ?? {};
  return {
    no: p.jerseyNumber ?? '-',
    name: p.name.toUpperCase(),
    f: s.f ?? 0,
    pts: s.pts ?? 0,
    reb: s.reb ?? 0,
    ast: s.ast ?? 0,
  };
}
